import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Ratios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: Math.floor(Math.random() * 2),
      random2: Math.floor(Math.random() * 12) + 1,
      ratioTab: [
        "1/8",
        "3/8",
        "5/8",
        "1/6",
        "1/5",
        "2/5",
        "3/5",
        "4/5",
        "1/4",
        "3/4",
        "1/3",
        "2/3",
        "1/2",
      ],
      percentTab: [
        "12.5",
        "37.5",
        "62.5",
        "16",
        "20",
        "40",
        "60",
        "80",
        "25",
        "75",
        "33",
        "66",
        "50",
      ],
      answer: "",
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerRatios = (event) => {
    event.preventDefault();
    var good = this.state.percentTab[this.state.random2];
    if (this.state.answer === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.ratioTab[this.state.random2] +
          " = " +
          good +
          "%",
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.ratioTab[this.state.random2] +
          " = " +
          good +
          "%",
      });
    }
    var que = Math.floor(Math.random() * 2);
    var rand2 = Math.floor(Math.random() * 12) + 1;
    this.setState({ question: que, random2: rand2, answer: "" });
  };

  mySubmitHandlerPercent = (event) => {
    event.preventDefault();
    var good = this.state.ratioTab[this.state.random2];
    if (this.state.answer === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.percentTab[this.state.random2] +
          "% = " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.percentTab[this.state.random2] +
          "% = " +
          good,
      });
    }
    var que = Math.floor(Math.random() * 2);
    var rand2 = Math.floor(Math.random() * 12) + 1;
    this.setState({ question: que, random2: rand2, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    if (this.state.question === 1) {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Ratios</h2>
            </div>
          </div>

          <div className="container">
            <p>Les questions peuvent être posées dans les 2 sens.</p>
            <p>
              Pour les pourcentages, pas besoin de noter le symbole %, notez
              simplement le nombre. Exemple : 90
            </p>
            <p>
              Pour les ratios, notez-le en entier, sans espace. Exemple : 9/10
            </p>

            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerRatios}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.ratioTab[this.state.random2]} ={" "}
                </label>
              </div>
              <input
                className="input-square"
                type="number"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Ratios</h2>
            </div>
          </div>

          <div className="container">
            <p>Les questions peuvent être posées dans les 2 sens.</p>
            <p>
              Pour les pourcentages, pas besoin de noter le symbole %, notez
              simplement le nombre. Exemple : 90
            </p>
            <p>
              Pour les ratios, notez-le en entier, sans espace. Exemple : 9/10
            </p>

            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerPercent}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.percentTab[this.state.random2]}% ={" "}
                </label>
              </div>
              <input
                className="input-square"
                type="text"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Ratios;
